<template>
  <div class="toast-position">
    <div class="toast-container">
      <transition-group tag="div" name="toast-list" class="toast-list col-block">
        <div class="toast col-block" :class="[toast.type]" v-for="(toast, index) in toasts" :key="toast.id" @mouseenter="e => keepToast(toast)" @mouseleave="e => leaveToast(toast, index)">
          <div class="option">
            <img :src="require('../../assets/images/toast-times.svg')" alt="" @click="e => removeToast(index)">
          </div>
          <div class="title">{{ toast.title || { error: $t('LAYOUT.dialog.toast.title.___error'/* Error */) + ' !', success: $t('LAYOUT.dialog.toast.title.___success'/* Success */) + ' !' }[toast.type] }}</div>
          <div class="content" v-html="toast.content"></div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      toasts: [],
      removeTimer: null
    }
  },
  computed: {
    ...mapGetters([
      'toast'
    ])
  },
  watch: {
    'toast' (nv) {
      let id = (new Date()).getTime() + ''
      this.toasts.push({
        ...nv,
        id: id,
        clearTimer: null,
        timer: setTimeout(() => {
          this.toasts.splice(this.toasts.indexOf(this.toasts.find(toast => toast.id === id)), 1)
        }, 5000)
      })
    }
  },
  methods: {
    keepToast (toast) {
      toast.clearTimer = setTimeout(() => {
        clearTimeout(toast.timer)
        toast.clearTimer = null
      }, 500)
    },
    leaveToast (toast, index) {
      if (toast.clearTimer) {
        clearTimeout(toast.clearTimer)
      } else {
        this.removeToast(index)
      }
    },
    removeToast (index) {
      if (this.removeTimer) return
      this.removeTimer = setTimeout(() => {
        this.toasts.splice(index, 1)
        setTimeout(() => {
          this.removeTimer = null
        }, 400)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/toast.vue